
import { api, upload } from '@/services/api';
import _ from 'underscore';
import Document from '@/classes/Document';
import {Module} from 'vuex';
import {RootState} from '@/types';

export interface DocumentState {
    documents: Document[];
    selectedDocument: Document | null;
}

export const DocumentStore: Module<DocumentState, RootState> = {

    namespaced: true,

    state: {
        documents: [],
        selectedDocument: null
    },

    getters: {

        documents(state): Document[] {
            return state.documents;
        },

        selectedDocument(state) {
            return state.selectedDocument;
        }
    },

    mutations: {

        setDocuments: (state, documents) => {
            state.documents = documents;
        },

        setSelectedDocument(state, document: Document) {
            state.selectedDocument = document;
        },

        addNewDocument(state, document: Document) {
            state.documents.push(document);
        },

        updateDocument(state, savedDocument: Document) {

            const document = _.find(state.documents, (d: Document) => {
                return d.id === savedDocument.id;
            });

            if (!document) {
                // TODO: Do we add it??
                return;
            }

            document.title = savedDocument.title;
            document.description = savedDocument.description;
            document.sharedWith = savedDocument.sharedWith;
            document.category = savedDocument.category;
        },

        removeDocument(state, id: number) {

            const idx = _.findIndex(state.documents, (d: Document) => {
                return d.id === id;
            });

            state.documents.splice(idx, 1);
        }
    },

    actions: {

        selectDocument({commit}, document: Document) {
            commit('setSelectedDocument', document);
        },

        loadDocuments({commit, dispatch}) {

            dispatch('documentCategories/loadCategories', null, {root: true})
                .then(() => {
                    api().get('documents')
                        .then((response) => {
                            const docs: Document[] = _.chain(response.data as Document[])
                                .map((d: Document) => {
                                    d.editTitle = d.title;
                                    d.editDescription = d.description;
                                    d.editSharedWith = d.sharedWith;
                                    d.editCategory = d.category;
                                    return d;
                                })
                                // TODO: Add sorting, or whatever else
                                .value();

                            commit('setDocuments', docs);

                        }).catch((err) => {
                        // TODO: Handle Error
                    });
                });
        },

        deleteDocument({commit}, id) {
            return new Promise((resolve, reject) => {
                api().delete('/documents/' + id, {

                }).then((response) => {
                    commit('removeDocument', id);
                    resolve(response);
                }).catch((err) => {
                    reject(err);
                });
            });
        },

        saveDocument({commit}, document: Document) {
            return  new Promise((resolve, reject) => {

                api().post('/documents/' + document.id, document)
                    .then((response) => {
                        commit('updateDocument', response.data as Document);
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        addNewDocument({commit}, document: Document) {
            return new Promise((resolve, reject) => {
                upload('/documents', document)
                    .then((response) => {
                        commit('addNewDocument', response.data as Document);
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    }
};
